export default __webpack_public_path__ + "static/media/backgroundmobile.5a431950.png";